import * as React from 'react';
import {AutoComplete, Icon, Input} from 'antd';
import {SelectValue} from "antd/lib/select";
import Fuse from "fuse.js";
import AwesomeDebouncePromise from "awesome-debounce-promise";

const {Option} = AutoComplete;

const keys = {
    TEXT: "text",
};
const {TEXT} = keys;
const fuseOptions = {
    shouldSort: true,
    threshold: 0.6,
    location: 0,
    distance: 50,
    maxPatternLength: 12,
    minMatchCharLength: 3,
    keys: [TEXT],
};

interface IProps {
    options: ISelectOption[];
    defaultValue?: SelectValue,
    allowClear?: boolean;
    placeholder?: string;
    onSelect?: (selectedValue: SelectValue, option: ISelectedOption) => any
    onChange?: (selectedValue: SelectValue) => void
}


interface IState {
    stateOptions: ISelectOption[];
    selectedValue: any;
    selectedText: String,
}

export interface ISelectOption {
    value: string;
    text: string;
}

export interface ISelectedOption extends Object {
    props?: {
        children: string | any;
    };
}

const searchAPI = (text: string, fuse: any) => fuse.search(text);

const searchAPIDebounced = AwesomeDebouncePromise(searchAPI, 0);

class FuseSelect extends React.Component<IProps, IState> {
    fuse: any;

    constructor(props: IProps) {
        super(props);
        this.state = {
            stateOptions: this.props.options,
            selectedValue: this.props.defaultValue,
            selectedText: "",
        }
        this.fuse = new Fuse(props.options, fuseOptions);
    }

    componentWillReceiveProps(nextProps: IProps) {
        this.setState({stateOptions: nextProps.options, selectedValue: nextProps.defaultValue})
        this.fuse = new Fuse(nextProps.options, fuseOptions);
    }

    onSelect = (selectedValue: SelectValue, option: ISelectedOption) => {
        this.setState({selectedValue, selectedText: option && option.props!.children});
        if (this.props.onSelect) {
            this.props.onSelect(selectedValue, option)
        }
    };
    onChange = (selectedValue: SelectValue) => {
        this.setState({selectedValue});
        if (this.props.onChange) {
            this.props.onChange(selectedValue)
        }
    };
    handleSearch = async (value: string) => {
        // let result = await searchAPIDebounced(value, this.fuse);
        let result = this.fuse.search(value)
        this.setState({stateOptions: result});
    };

    render() {
        const {stateOptions} = this.state;
        const children = stateOptions.map((org: ISelectOption) => <Option key={org.value}>{org.text}</Option>);
        const placeholder = this.props.placeholder ? this.props.placeholder : "Type to select...";

        return (
            <AutoComplete
                value={this.state.selectedValue}
                allowClear={this.props.allowClear ? this.props.allowClear : false}
                dataSource={children}
                style={{width: 300}}
                defaultValue={this.state.selectedValue}
                onSelect={this.onSelect}
                onSearch={this.handleSearch}
                onChange={this.onChange}
                placeholder={placeholder}
            >
                <Input suffix={<Icon type="search" className="certain-category-icon" />} />
            </AutoComplete>
        )
    }
}

export default FuseSelect;
